import store from "../../store";
import orders from './orders.vue';


window.USER =  new Vue({
	store,
	el: 'div#orders_view',

	name : "ORDER_BLOCK",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		orders,
	}
});
